import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import GrainOverlay from "@/components/GrainOverlay";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/EditorialMarquee";
import TrailSection from "@/components/TrailSection";

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
        };
    }, []);

    return (
        <main className="relative bg-[#0B1612] text-[#F5F5F0] antialiased selection:bg-[#C85A17] selection:text-[#F5F5F0]">
            <GrainOverlay />
            <Hero />
            <EditorialMarquee />
            <TrailSection />
            <footer
                data-testid="site-footer"
                className="relative z-10 flex items-center justify-center border-t border-white/10 bg-[#0B1612] py-7"
            >
                <p className="font-mono-mm text-[0.65rem] uppercase tracking-[0.3em] text-[#A3B8AD]/70">
                    &copy; {new Date().getFullYear()} Mane Miles
                </p>
            </footer>
        </main>
    );
}

export default App;
